import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { WorkOrder } from '../WorkOrder'
import type { IAction } from '../../action/IAction'

@InputType()
export class RefreshWorkOrderInsufficientItemsArgs extends ActionArgs {
  @Field(() => ID)
  workOrderId: string
}

export interface IRefreshWorkOrderInsufficientItems extends IAction<WorkOrder, RefreshWorkOrderInsufficientItemsArgs> {}
